export default "__VITE_ASSET__SIe7uyFe__"